<script setup lang="ts">
import RcSeparator from '@components/RcSeparator/RcSeparator.vue';
</script>

<template>
  <RcSeparator :decorative="false" />
</template>
